import React, { useRef } from "react";

import setDatos from "../../services/setDatos";

export const UploadFileIcon = ({ icon, idComponente }) => {
  const refInputFileIcon = useRef(null);

  const handleClickInput = () => {
    refInputFileIcon.current.click();
  };

  const handleChangeFileBanner = async ({ target }) => {
    const formData = new FormData();

    formData.append("carpeta", 6);
    formData.append("subCarpeta", idComponente);
    formData.append("archivos", target.files[0]);

    await setDatos(`atributos/archivos`, formData);

    alert("Archivo guardado exitosamente");
  };

  return (
    <>
      <button className="edit-img-admin" onClick={handleClickInput}>
        {icon}
      </button>
      <input
        type={"file"}
        ref={refInputFileIcon}
        className={"hide"}
        onChange={handleChangeFileBanner}
        accept={"image/*"}
      />
    </>
  );
};
